import { useEffect, useState } from 'react';

const iso = (d) => d.toISOString().slice(0, 10);
const addDays = (isoDate, n) => { const d = new Date(isoDate); d.setDate(d.getDate() + n); return iso(d); };
const today = () => iso(new Date());

const step = {
  width:30, height:30, borderRadius:9, flexShrink:0, cursor:'pointer', border:'1px solid rgba(14,138,122,0.25)',
  background:'#fff', color:'#0e8a9c', fontWeight:800, fontSize:16, lineHeight:1, display:'flex',
  alignItems:'center', justifyContent:'center', userSelect:'none',
};
const field = {
  width:'100%', padding:'10px 12px', borderRadius:12, border:'1px solid rgba(14,138,122,0.22)',
  background:'#fff', fontSize:14, fontFamily:'inherit', color:'#0c2b2f',
};

function Stepper({ label, value, min, max, onChange }) {
  return (
    <div>
      <div style={{ fontSize:11.5, fontWeight:800, color:'#5a726f', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:6 }}>{label}</div>
      <div style={{ display:'flex', alignItems:'center', gap:9 }}>
        <span style={{ ...step, opacity: value <= min ? 0.4 : 1 }} onClick={() => value > min && onChange(value - 1)}>−</span>
        <span style={{ fontWeight:800, fontSize:16, minWidth:18, textAlign:'center' }}>{value}</span>
        <span style={{ ...step, opacity: value >= max ? 0.4 : 1 }} onClick={() => value < max && onChange(value + 1)}>+</span>
      </div>
    </div>
  );
}

/**
 * Dates and who is travelling. Children are collected as ages, not a count, because the supplier
 * prices age bands — and each hotel draws its own, so the ceiling comes from the hotel.
 */
export default function StayPicker({ maxAdults = 4, maxChildren = 0, oldestChildAge = 12, value, onChange }) {
  const { stayFrom, stayTo, adults, childAges } = value;
  const [minDepart, setMinDepart] = useState(addDays(today(), 1));

  useEffect(() => { if (stayFrom) setMinDepart(addDays(stayFrom, 1)); }, [stayFrom]);

  const set = (patch) => onChange({ ...value, ...patch });

  const setArrival = (v) => {
    // Keeping a departure that is now before the arrival would just produce an error on the server.
    const nextTo = stayTo && stayTo <= v ? addDays(v, 3) : stayTo;
    set({ stayFrom: v, stayTo: nextTo });
  };

  const setChildCount = (n) => {
    const next = childAges.slice(0, n);
    while (next.length < n) next.push(6);
    set({ childAges: next });
  };

  return (
    <div style={{ display:'grid', gap:13 }}>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
        <label>
          <div style={{ fontSize:11.5, fontWeight:800, color:'#5a726f', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:6 }}>Arrive</div>
          <input type="date" value={stayFrom} min={today()} onChange={e => setArrival(e.target.value)} style={field} />
        </label>
        <label>
          <div style={{ fontSize:11.5, fontWeight:800, color:'#5a726f', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:6 }}>Depart</div>
          <input type="date" value={stayTo} min={minDepart} onChange={e => set({ stayTo: e.target.value })} style={field} />
        </label>
      </div>

      <div style={{ display:'grid', gridTemplateColumns: maxChildren > 0 ? '1fr 1fr' : '1fr', gap:10 }}>
        <Stepper label="Adults" value={adults} min={1} max={Math.max(1, maxAdults)} onChange={v => set({ adults: v })} />
        {maxChildren > 0 && (
          <Stepper label="Children" value={childAges.length} min={0} max={maxChildren} onChange={setChildCount} />
        )}
      </div>

      {childAges.length > 0 && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(108px,1fr))', gap:8 }}>
          {childAges.map((age, i) => (
            <label key={i}>
              <div style={{ fontSize:11.5, fontWeight:700, color:'#5a726f', marginBottom:5 }}>Child {i + 1} age</div>
              <select value={age} style={field}
                onChange={e => { const next = [...childAges]; next[i] = Number(e.target.value); set({ childAges: next }); }}>
                {Array.from({ length: (oldestChildAge ?? 12) + 1 }, (_, a) => (
                  <option key={a} value={a}>{a === 0 ? 'Under 1' : a}</option>
                ))}
              </select>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
